import Resource from "./resource.js";
export class Workflows extends Resource {
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/workflows",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
    }
    find = this.makeRequest({
        method: "GET",
        path: "/",
    });
    findOne = this.makeRequest({
        method: "GET",
        path: "/{id}",
        urlParamKeys: ["id"],
        queryParamKeys: ["includeId"],
        catchNotFound: true,
    });
    update = this.makeUpdateRequest({
        method: "PUT",
        path: "/{id}",
        urlParamKeys: ["id"],
    });
    create = this.makeRequest({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        returnResourceIdInLocationHeader: { field: "id" },
    });
    createAsYaml = this.makeRequest({
        method: "POST",
        headers: { "Content-Type": "application/yaml", Accept: "application/yaml" },
        returnResourceIdInLocationHeader: { field: "id" },
        payloadKey: "yaml",
    });
    delById = this.makeRequest({
        method: "DELETE",
        path: "/{id}",
        urlParamKeys: ["id"],
    });
}
